import * as React from 'react';

import {colors} from '../colors/colors';
import {AiSparkleNewIcon} from '../icon/svg/ai-sparkle-new-icon';
import {Body} from '../typography/body';

import styles from './ai-suggestion-pill.module.css';

type Props = {
    label: string;
    onClick: () => void;
};

export const AiSuggestionPill = (props: Props) => {
    return (
        <button onClick={props.onClick} className={styles['button-container']}>
            {/* @ts-expect-error */}
            <AiSparkleNewIcon size={12} color={colors.aiPurplePrimary} wrapWithDiv={false} />
            <Body size='small' color='ai-purple-dk'>
                {props.label}
            </Body>
        </button>
    );
};
